"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimalMicrobeProtection = void 0;
var vue_1 = require("vue");
exports.AnimalMicrobeProtection = vue_1.default.component('AnimalMicrobeProtection', {
    props: {},
    methods: {},
    template: "\n    <div class=\"shield_icon_animal_microbe\" style=\"font-size:13px\"></div>\n  ",
});
//# sourceMappingURL=AnimalMicrobeProtection.js.map